
import React, { useState, useEffect } from 'react';
import { Button } from '../base/Button';

export const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/d4f551a0-0f82-4a97-9c1e-d5ecd7883897.png" 
              alt="DEN d.o.o. Logo" 
              className="h-8 w-auto mr-3"
            />
            <h1 className={`text-2xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              DEN d.o.o.
            </h1>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-base font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('vpn')}
              className={`text-base font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              VPN
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className={`text-base font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-base font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-base font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className={`text-base font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              FAQ
            </button>
          </div>

          <Button 
            variant={isScrolled ? 'primary' : 'outline'} 
            size="sm"
            onClick={() => scrollToSection('contact')}
          >
            Get Started
          </Button>
        </div>
      </div>
    </nav>
  );
};
